import React, { useCallback } from "react";
import classnames from "classnames";
import { SensorDataSessionMarker } from "@shared/models";

import "./index.scss";

interface SensorDataSessionMarkersProps {
  width: number;
  markers: SensorDataSessionMarker[];
  activeMarker: SensorDataSessionMarker | null;
  onSelectMarker: (marker: SensorDataSessionMarker) => void;
  onDeleteMarker: (marker: SensorDataSessionMarker) => void;
}

const SensorDataSessionMarkers = (props: SensorDataSessionMarkersProps) => {
  const { width, markers, activeMarker, onSelectMarker, onDeleteMarker } = props;

  const selectItem = useCallback(
    (item: SensorDataSessionMarker) => {
      onSelectMarker(item);
    },
    [onSelectMarker],
  );

  return (
    <div className="sensor-data-session-markers">
      <div
        className={classnames("markers-items", { rightPadding: !!markers.length })}
        style={{ maxWidth: `${width + 50}px` }}
      >
        {markers.map((item: SensorDataSessionMarker) => (
          <div
            className="markers-item"
            key={item.id}
            onClick={() => selectItem(item)}
            style={{
              color: item.color,
              ...(activeMarker?.id === item.id ? { borderTop: `5px solid ${item.color}`, fontWeight: 700 } : {}),
            }}
          >
            <div>{item.title}</div>
            <div className="delete-marker" onClick={() => onDeleteMarker(item)}>
              x
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SensorDataSessionMarkers;
